import * as React from 'react'
import {
	Alert,
	Form,
	FormGroup,
	FormControl,
	ControlLabel,
	HelpBlock,
	Button,
	Checkbox,
	Row,
	Col,
} from 'react-bootstrap'
import { TrackEvent } from './../common/Analytics'
import LanguageSelect from '../common/LanguageSelect'
import GoogleSigninButton from '../common/googleLogin/GoogleSigninButton'
import MicrosoftSigninButton from '../common/microsoftLogin/MicrosoftSigninButton'
import { microsoftLoginSignupHandler, googleLoginSignupHandler } from '../common/GoogleMicrosoftApiCall'
import jwt_decode from 'jwt-decode'

import 'whatwg-fetch'
interface SignupState {
	captchaState: any
	passwordState: 'error' | 'success' | 'warning' | null
	password2State: 'error' | 'success' | 'warning' | null
	firstnameState: 'error' | 'success' | 'warning' | null
	phoneState: 'error' | 'success' | 'warning' | null
	languageState: 'error' | 'success' | 'warning' | null
	accountSuccess: string | boolean
	username: string
	password: string
	password2: string
	firstname: string
	lastname: string
	phone: string
	language: string
	response: undefined
	status: string
	errors: string[]
	token: string
	creating: boolean

	read: boolean
	accepted: boolean
	mediaLogin: boolean
	msClientId: string
	googleClientId: string
}

interface UserInfo {
	firstname?: string
	password?: string
	contact_phone?: string
	lastname?: string
	response?: string
	token?: string
	language?: string
	signupUsingMedia?: boolean
}

export default class Signup extends React.Component<{}, SignupState> {
	private signUpSuccess: boolean
	private eventCategoryPrefix: string

	constructor(props: object) {
		super(props)
		this.state = {
			username: '',
			password: '',
			password2: '',
			firstname: '',
			lastname: '',
			phone: '',
			response: undefined,
			status: 'account',
			errors: [],
			token: '',
			language: 'en',
			passwordState: null,
			password2State: null,
			firstnameState: null,
			phoneState: null,
			captchaState: null,
			languageState: null,
			creating: false,
			accountSuccess: false,
			read: false,
			accepted: false,
			mediaLogin: false,
			msClientId: '',
			googleClientId: '',
		}
		this.signUpSuccess = false
		this.eventCategoryPrefix = window.location.search.indexOf('embed=true') > -1 ? '(embed) ' : ''
	}
	// Track form abandonment with fields which are set
	private triggerFormAbandonmentEvent = (): void => {
		if (this.signUpSuccess) {
			return
		}
		const category = this.eventCategoryPrefix + 'sign up activation form abandonment'
		const action = []

		if (this.state.username) {
			action.push('username')
		}
		if (this.state.password) {
			action.push('password')
		}
		if (this.state.firstname) {
			action.push('first name')
		}
		if (this.state.lastname) {
			action.push('last name')
		}
		if (this.state.phone) {
			action.push('phone')
		}
		if (this.state.language) {
			action.push('language')
		}

		const element = document && document.querySelector('.help-block')
		const label = (element && element.textContent) || undefined

		TrackEvent(category, action.length > 0 ? action.join(' > ') : '(nothing set)', label, 0, true)
	}

	public componentDidMount() {
		const root = document.getElementById('root')
		if (root) {
			const status = root.getAttribute('data-status') || ''
			const username = root.getAttribute('data-email') || ''
			const token = root.getAttribute('data-token') || ''
			const language = root.getAttribute('data-language') || ''
			const msClientId = root.getAttribute('data-ms-id') || ''
			const googleClientId = root.getAttribute('data-google-id') || ''
			this.setState({ status, username, token, language, msClientId, googleClientId })
		}
		window.addEventListener('beforeunload', this.triggerFormAbandonmentEvent)
		window.history.pushState({}, '', '/users/signup/account/')
	}

	public UNSAFE_componentWillUnmount() {
		window.removeEventListener('beforeunload', this.triggerFormAbandonmentEvent)
	}

	private inputChangeHandler = (e: any): void => {
		const input = e.target as HTMLInputElement
		this.setState({
			passwordState: null,
			firstnameState: null,
			phoneState: null,
			password2State: null,
		})
		const key = input.id
		const val = input.value
		const obj: any = {}
		obj[key] = val
		this.setState(obj)
	}
	public verifyCallback = (response: undefined): void => {
		this.setState({ response, captchaState: null })
	}

	private setLanguage = (language: string) => {
		this.setState({ language, languageState: null })
	}
	private validate = (user: UserInfo): boolean => {
		let ret = true

		if (!this.state.mediaLogin && (!user.password || user.password.length < 8)) {
			this.setState({ passwordState: 'error' })
			ret = false
		}
		if (!user.firstname) {
			this.setState({ firstnameState: 'error' })
			ret = false
		}
		if (!user.contact_phone) {
			this.setState({ phoneState: 'error' })
			ret = false
		}
		if (!user.language) {
			this.setState({ languageState: 'error' })
			ret = false
		}
		if (!this.state.mediaLogin && user.password !== this.state.password2) {
			this.setState({ password2State: 'error' })
			ret = false
		}
		return ret
	}

	private microsoftLogin = async () => {
		try {
			const { result, respFromMicrosoftApi } = await microsoftLoginSignupHandler(this.state.msClientId)
			if (this.state.username !== respFromMicrosoftApi.account?.username) {
				this.setState({
					accountSuccess: 'media login error',
					errors: [`You must be signed in your Microsoft account with ${this.state.username} `],
				})
			}
			if (result.status === 'OK' && this.state.username === respFromMicrosoftApi.account?.username) {
				this.setState({ mediaLogin: true })
				this.setState({
					// split the firstname and lastname from fullname
					firstname: respFromMicrosoftApi.account.name
						? respFromMicrosoftApi.account.name
							?.split(' ')
							.slice(0, -1)
							.join(' ')
						: '',
					lastname: respFromMicrosoftApi.account.name
						? respFromMicrosoftApi.account.name
							?.split(' ')
							.slice(-1)
							.join(' ')
						: '',
				})
			}
		} catch (error) {
			this.setState({
				accountSuccess: 'media login error',
				errors: [`There was an error while retrieving data from your Microsoft account`],
			})
		}
	}

	private googleLogin = async (response: any) => {
		try {
			const googleCredential = response?.credential
			const decoded: any = jwt_decode(googleCredential)
			const result = await googleLoginSignupHandler(response)
			if (this.state.username !== decoded.email) {
				this.setState({
					accountSuccess: 'media login error',
					errors: [`You must be signed in your Google account with ${this.state.username} `],
				})
			}
			if (result.status === 'OK' && this.state.username === decoded.email) {
				this.setState({ mediaLogin: true })
				this.setState({
					firstname: decoded.given_name,
					lastname: decoded.family_name,
				})
			}
		} catch (error) {
			this.setState({
				accountSuccess: 'media login error',
				errors: [`There was an error while retrieving data from your Google account`],
			})
		}
	}

	private createAccount = async () => {
		const user: UserInfo = {}
		user.password = this.state.password
		user.firstname = this.state.firstname
		user.lastname = this.state.lastname
		user.contact_phone = this.state.phone
		user.response = this.state.response
		user.language = this.state.language
		user.signupUsingMedia = this.state.mediaLogin
		const validationSuccess = this.validate(user)
		if (validationSuccess) {
			user.token = this.state.token
			this.setState({ creating: true })
			const responseObject = await fetch('/users/createAccount', {
				credentials: 'same-origin',
				body: JSON.stringify({ values: user }),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				method: 'POST',
			})
			if (responseObject.ok) {
				const resp = await responseObject.json()
				if (resp.status === 'in' || resp.status === 'auth error') {
					const url = resp.status === 'in' ? '/users/signupLogin' : '/users/login'
					this.setState({ creating: false, accountSuccess: true })
					setTimeout(() => {
						window.location.replace(url)
					}, 3000)
					this.signUpSuccess = true
					TrackEvent(this.eventCategoryPrefix + 'sign up confirmation', 'success')
				}
				if (resp.status === 'db error') {
					this.setState({ creating: false, accountSuccess: 'db error' })
					TrackEvent(this.eventCategoryPrefix + 'sign up confirmation', 'fail', 'db error')
				}
				if (resp.status === 'validation error') {
					const errors = resp.errors
					this.setState({
						creating: false,
						accountSuccess: 'validation error',
						errors: Object.keys(errors).map((res) => errors[res][0]),
					})
					TrackEvent(this.eventCategoryPrefix + 'sign up confirmation', 'fail', 'validation error')
				}
			}
		} else {
			this.setState({
				creating: false,
				accountSuccess: 'validation error',
				errors: ['Please fill up all the required fields'],
			})
		}
	}

	private signupButtonStyle = {
		width: '100%',
		maxWidth: '280px',
		marginBottom: '10px',
		margin: '0px auto',
	}
	public render() {
		const showMsg = () => {
			if (this.state.accountSuccess === true) {
				return (
					<Alert bsStyle="success">
						<strong>
							Your account has been created successfully! <br />
							You will be redirected shortly.
						</strong>
					</Alert>
				)
			}
			if (this.state.accountSuccess === 'db error') {
				return (
					<Alert bsStyle="danger">
						<strong>
							There was a problem creating your account! <br /> Please refresh the page and retry.
						</strong>
					</Alert>
				)
			}
			if (this.state.accountSuccess === 'validation error') {
				let str = ''
				this.state.errors.forEach((err) => (str += err + '\n'))
				return (
					<Alert bsStyle="danger">
						<strong>
							Please correct the following errors and retry: <br /> {str}
						</strong>
					</Alert>
				)
			}
			if (this.state.accountSuccess === 'media login error') {
				let str = ''
				this.state.errors.forEach((err) => (str += err + '\n'))
				return (
					<Alert bsStyle="danger">
						<strong>{str}</strong>
					</Alert>
				)
			}
		}
		return (
			<div>
				{showMsg()}

				<h1>{this.state.status === 'account' ? 'Create Account' : 'Sign Up'}</h1>
				<div className="loginbuttons" style={this.signupButtonStyle}>
					{this.state.msClientId && (
						<>
							<MicrosoftSigninButton
								microsoftLogin={this.microsoftLogin}
								text="Sign in with Microsoft"
								width="280px"
							/>
							<Row>
								<Col xs={12} style={{ textAlign: 'center', marginBottom: '5px' }}>
									<b>OR</b>
								</Col>
							</Row>
						</>
					)}
					{this.state.googleClientId && (
						<GoogleSigninButton
							clientId={this.state.googleClientId}
							googleLogin={this.googleLogin}
							text="signin_with"
							width="280"
						/>
					)}
				</div>
				{this.state.googleClientId && (
					<Row>
						<Col xs={12} style={{ textAlign: 'center', margin: '15px 0px 8px' }}>
							<b>OR</b>
						</Col>
					</Row>
				)}
				<Form>
					<FormGroup>
						<ControlLabel>Email</ControlLabel>
						<FormControl type="email" value={this.state.username} disabled />
					</FormGroup>

					{!this.state.mediaLogin && (
						<FormGroup controlId="password" validationState={this.state.passwordState}>
							<ControlLabel>Password</ControlLabel>
							<FormControl
								type="password"
								value={this.state.password}
								onChange={this.inputChangeHandler}
							/>
							{this.state.passwordState ? (
								<HelpBlock>Please supply a password (min. 8 characters).</HelpBlock>
							) : (
								''
							)}
						</FormGroup>
					)}
					{!this.state.mediaLogin && (
						<FormGroup controlId="password2" validationState={this.state.password2State}>
							<ControlLabel>Repeat Password</ControlLabel>
							<FormControl
								type="password"
								value={this.state.password2}
								onChange={this.inputChangeHandler}
							/>
							{this.state.password2State ? <HelpBlock>Passwords don't match!</HelpBlock> : ''}
						</FormGroup>
					)}

					<FormGroup controlId="firstname" validationState={this.state.firstnameState}>
						<ControlLabel>Firstname</ControlLabel>
						<FormControl type="text" value={this.state.firstname} onChange={this.inputChangeHandler} />
						{this.state.firstnameState ? <HelpBlock>Firstname is required.</HelpBlock> : ''}
					</FormGroup>

					<FormGroup controlId="lastname">
						<ControlLabel>Lastname</ControlLabel>
						<FormControl type="text" value={this.state.lastname} onChange={this.inputChangeHandler} />
					</FormGroup>

					<FormGroup controlId="phone" validationState={this.state.phoneState}>
						<ControlLabel>Phone Number</ControlLabel>
						<FormControl type="number" value={this.state.phone} onChange={this.inputChangeHandler} />
						{this.state.phoneState ? <HelpBlock>Phone number is required.</HelpBlock> : ''}
					</FormGroup>

					<FormGroup controlId="language" validationState={this.state.languageState}>
						<ControlLabel>Language</ControlLabel>
						<LanguageSelect language={this.state.language} languageChanged={this.setLanguage} />
					</FormGroup>

					<FormGroup controlId="tos">
						<Checkbox checked={this.state.read} onChange={() => this.setState({ read: !this.state.read })}>
							I have read and understand the{' '}
							<a href="https://readpeak.com/terms-of-service" target="_blank">
								terms of service
							</a>
						</Checkbox>
						<Checkbox
							checked={this.state.accepted}
							onChange={() => this.setState({ accepted: !this.state.accepted })}
						>
							I accept the{' '}
							<a href="https://readpeak.com/terms-of-service" target="_blank">
								terms of service
							</a>
						</Checkbox>
					</FormGroup>

					<Button
						bsStyle="primary"
						disabled={this.state.creating || !this.state.read || !this.state.accepted}
						onClick={!this.state.creating ? this.createAccount : undefined}
						block
					>
						{this.state.creating ? 'Creating Account...' : 'Create Account'}
					</Button>
				</Form>
			</div>
		)
	}
}
